// // src/Modal.js
// import React from "react";
// import "./Modal.css"; // We'll create some basic styles for the modal

// const Modal = ({ content, onClose }) => {
//   return (
//     <div className="modal-overlay" onClick={onClose}>
//       <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//         <button className="modal-close" onClick={onClose}>X</button>
//         <div className="modal-body modal-content">
//           <p className="bg bg-light p-3">{content}</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Modal;


import React, { useEffect } from "react";
import "./Modal.css"; // We'll create some basic styles for the modal

const Modal = ({ content, onClose }) => {


  useEffect(() => {
    // Close on Escape
    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        onClose?.();
      }
    };

    // Lock background scroll
    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    // Attach key listener
    document.addEventListener("keydown", handleEscapeKey);

    // Focus the dialog container for a11y
    const t = setTimeout(() => {
      document.getElementById("app-modal-dialog")?.focus();
    }, 0);

    // Cleanup
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = originalOverflow;
      clearTimeout(t);
    };
  }, [onClose]);

  // useEffect(() => {
  //   // Add event listener for Escape key press
  //   const handleEscapeKey = (e) => {
  //     if (e.key === "Escape") {
  //       onClose(); // Close the modal if Escape is pressed
  //     }
  //   };

  //   // Attach the event listener when the modal is opened
  //   document.addEventListener("keydown", handleEscapeKey);

  //   // Cleanup the event listener when the modal is closed
  //   return () => {
  //     document.removeEventListener("keydown", handleEscapeKey);
  //   };
  // }, [onClose]); // Only re-run if onClose changes

  return (
    <div className="modal-overlay" onClick={onClose}>
      {/* <div className="modal-content" onClick={(e) => e.stopPropagation()}> */}

      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label="Modal dialog"
        tabIndex={-1}
        id="app-modal-dialog"
      >

        {/* <button className="modal-close" onClick={onClose}>X</button> */}
        <button className="modal-close" onClick={onClose} aria-label="Close dialog" title="Close">×</button>
        <div className="modal-body bg bg-light p-3 rounded-3" >
          {/* <p>{content}</p> */}

          <p style={{
            whiteSpace: 'pre-wrap', wordBreak: 'break-word', margin: 0, overflow: "scroll",
            // height: "660px"
          }}>
            {content}
          </p>

        </div>
      </div>
    </div>
  );
};

export default Modal;
